module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"NEW MESSAGES"},"et":{"title":"NEW MESSAGES"},"ru":{"title":"NEW MESSAGES"}}')
  delete Component.options._Ctor
}
